<template>
    <div>
        <DsModal
            is-open
            size="fullscreen"
            show-close
            :title="$t('accessRequest')"
            data-qa="access-request-modal"
            @close="close"
        >
            <template #default>
                <DsBox class="invite-body">
                    <DsStack space="spacing-200">
                        <DsText variant="display-alt">
                            {{ $t('grantPartnerAccess') }}
                        </DsText>

                        <DsText class="body-desc" variant="body">
                            {{ $t('partnerAccessDescription') }}
                        </DsText>

                        <PartnerCompanyInfo />
                    </DsStack>
                </DsBox>
            </template>
        </DsModal>
    </div>
</template>

<script>
import PartnerCompanyInfo from './PartnerCompanyInfo.vue';

export default {
    name: 'InvitePage',
    components: {
        PartnerCompanyInfo,
    },
    data() {
        return {};
    },
    methods: {
        close() {
            this.$router.push({ name: 'home' });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';

.invite-body {
    width: min(90%, px-to-rem(800px));
    margin: 0 auto;
}

.body-desc {
    max-width: px-to-rem(500);
}
</style>

<i18n>
{
    "en": {
        "accessRequest": "Access request",
        "grantPartnerAccess": "Grant Partner access to your app",
        "partnerAccessDescription": "You're allowing a Keap Partner to access your app. Partner access is free and doesn't count against your user licenses."
    }
}
</i18n>
